module.exports = __webpack_public_path__ + "img/SSO.701cde40.svg";